export const Textarea = {
  baseStyle: {
    background: 'transparent',
    border: 0,
    borderStyle: 'solid',
    borderWidth: 0,
    borderBottomWidth: '1px',
    boxShadow: 'currentcolor 0px 0px 0px inset',
    transition: '0.6s',
    px: 0,
    borderRadius: 0,
    WebkitAppearance: 'none',
    height: 'auto',
    '&:focus': {
      boxShadow: 'currentcolor 0px -3px 0px inset',
    },
  },
}
